import { render, staticRenderFns } from "./VendorApp.vue?vue&type=template&id=eea4df9e"
import script from "./VendorApp.vue?vue&type=script&lang=js"
export * from "./VendorApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports